import { render } from "./MessengerAccounts.vue?vue&type=template&id=3cbeea50&scoped=true"
import script from "./MessengerAccounts.vue?vue&type=script&lang=js"
export * from "./MessengerAccounts.vue?vue&type=script&lang=js"

import "./MessengerAccounts.vue?vue&type=style&index=0&id=3cbeea50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbeea50"]])

export default __exports__